import {
  useMutation,
  type QueryKey,
  type UseMutationOptions,
  type UseMutationResult,
} from '@tanstack/react-query';
import { AxiosError, AxiosResponse } from 'axios';

import { api } from '@/utils/api';
import { ApiErrorResponse, ApiResponse } from '@/types/api';

export interface DeleteFileRequest {
  fileId: number;
}

export const deleteFile = ({ fileId }: DeleteFileRequest) => {
  return api.delete<ApiResponse<undefined>>('/file', {
    params: {
      fileId,
    },
  });
};

const useDeleteFile = <TError = AxiosError<ApiErrorResponse>>(
  options?: UseMutationOptions<
    AxiosResponse<ApiResponse<undefined>>,
    TError,
    DeleteFileRequest,
    QueryKey
  >,
): UseMutationResult<
  AxiosResponse<ApiResponse<undefined>>,
  TError,
  DeleteFileRequest,
  QueryKey
> => {
  return useMutation(deleteFile, {
    ...options,
  });
};

export default useDeleteFile;
